export const GOOGLE_CHAT_SPACES_PREFIX = 'spaces/';
export const GOOGLE_CHAT_SPACE_PREFIX = 'space/';
export const GOOGLE_CHAT_ROOM_PREFIX = 'room/';
